import React from 'react';

import { useNavigate } from 'react-router-dom';

import Header from '../../blocks/header';
import CreateRole from '../../forms/createRole';
import Elevation from '../../themed/instruction-modals/elevation';
import Instruction from '../../themed/instruction-modals/instruction';
import Roles from './roles';

import { tutorialConstants } from '../../../utils/constants';
import { getTutorials, setActiveTutorial } from '../../../store/tutorials';
import { useAppDispatch, useAppSelector } from '../../../store/configureStore';

import className from './roles.module.scss';
import routes from '../../../utils/routes';

const AddRole: React.FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const tutorials = useAppSelector(getTutorials);

	const isActive =
		tutorials.activeTutorial === tutorialConstants.SETUP_PRIVILEGES;

	const handleViewNextTutorial = () => {
		dispatch(setActiveTutorial(tutorialConstants.SETUP_USER));
		navigate(routes.users.fullPath);
	};

	return (
		<React.Fragment>
			<Instruction
				isVisible={isActive}
				onProceed={handleViewNextTutorial}
				title="SetUp Privileges!"
				message="Complete the form above to create a new role with custom privileges!"
			/>

			<Header subtitle="Add a New Role" />

			<div className={className.roles}>
				<Elevation isElevated={isActive}>
					<div className={className['roles-body']}>
						<CreateRole />
					</div>
				</Elevation>

				<div className={className['roles-body']}>
					<Roles />
				</div>
			</div>
		</React.Fragment>
	);
};

export default AddRole;
